!function(window) {
function tableStackedAreaSelection(options){
	
	// need to delegate click because content will be added and removed
	// all the time
	$('.iopr-data-wrapper').on('click', 'tr.value-row', function (ev) {
		ev.stopPropagation();
		var $tr = $(this);
		// save parent
		options.properties.setParentFromTable($tr);
		if (options.charts.stackedArea.chart) {
			// regenerate chart if exists
			options.charts.stackedArea.generate();
		}
	});

}

module.exports = tableStackedAreaSelection;
window.tableStackedAreaSelection = tableStackedAreaSelection;
}.call(window, window);